import { Box, Button, IconChevronLeft, IconClear } from '@capitalise/ui-design-system';
import { useCreditLimitContext } from '../../hooks/useCreditLimitContext';

const CreditLimitTopNav = () => {
  const { step, onStepBack, onClose } = useCreditLimitContext();
  return (
    <Box
      p="xsmall"
      display="flex"
      justifyContent={step === 1 ? 'flex-end' : 'space-between'}
      data-testid="CreditLimitTopNav"
    >
      {step !== 1 && (
        <Button
          leftIcon={<IconChevronLeft />}
          onClick={onStepBack}
          variant="text"
          baseColor="green"
        >
          Back
        </Button>
      )}
      <Box
        as="button"
        onClick={onClose}
        backgroundColor="grey-50"
        borderRadius="100px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        hover={{
          backgroundColor: 'grey-100',
        }}
        width="medium"
        height="medium"
        data-testid="button-close"
      >
        <IconClear width="2xsmall" height="2xsmall" />
      </Box>
    </Box>
  );
};

export default CreditLimitTopNav;
